import request from "../utils/request";
import {ConstConfig} from "../constants";

export function getQiniuUploadToken() {
    const params = {
        deadline: 3600,
        scope: 'snsports',
        strict: true
    }
    return request({
        url: process.env.VUE_APP_CB_API + ConstConfig.apiPath + '/GetQiniuUploadToken.json',
        method: 'get',
        params
    })
}

/* upload images */
export function uploadImage(data) {
    return request({
        url: ConstConfig.qiniuUpload,
        method: 'post',
        qs: false,
        headers: { 'Content-Type': 'multipart/form-data' },
        data
    })
}